<template>
  <div class="pro-subscribe">
<!--    <img :src="propsParam.icon" style="margin-top: 40px" width="48" height="48">-->
    <div class="pro-subscribe-list"> 
      <div class="pro-subscribe-list-item" v-for="(item, index) in proList" :key="index"> 
        <div class="item-top">
          <div class="title" style="width: 100%; text-align: center;">{{item.title}}</div>
          <div :class="`${item.isCustomized ? 'title_desc_customized' : 'title_desc'}`">
            <el-tooltip :content="item.subTitle" placement="top" effect="dark" style="max-width: 300px; word-wrap: break-word;">
              <div class="pro-subscribe-subTitle">{{ item.subTitle }}</div>
              <template #content>
                <div style="max-width: 300px; word-wrap: break-word;">
                  <div class="pro-subscribe-subTitle">{{ item.subTitle }}</div>
                </div>
              </template>
            </el-tooltip>
          </div>
        </div>
        <div class="priceItem" v-if="!item.isCustomized">
          <!-- 字符和多少页PDF -->
          <div class="item-char" v-if="!item.isCustomized && item.charNum">
            <div class="item-char-title" :style="`font-size: ${getStyleFontSize()}`">{{$t('pro_business_subscribe_item_char_year').replace('*', item.charNum / 10000)}}</div>
          </div>
          <!-- 价格 -->
          <div class="item-pdf" v-if="!item.isCustomized && item.pageNum">
            <div class="item-pdf-title">{{ $t('pro_business_subscribe_item_pdf_page').replace('*', item.pageNum) }}</div>
          </div>
        </div>
        <div class="item-price" v-if="!item.isCustomized && item.realPrice" @click="onSubscribe(item)">
          <div class="item-price-title" v-if="coin != 'jpy' && coin != 'JPY'">{{getCurrencyTitle()}}{{ bizTeamInfo.agentUid ? item.bizAgentRealPrice : item.realPrice}}</div>
          <div class="item-price-title" v-else>{{ bizTeamInfo.agentUid ? item.bizAgentRealPrice : item.realPrice}}{{getCurrencyTitle()}}</div>
        </div>
        <div class="item-customized" v-if="item.isCustomized" @click="onCustomized(item)">
          <div class="item-customized-title">{{ $t('pro_business_subscribe_item_customized_btn') }}</div>
        </div>

        <div class="freeLine" />
        <div class="tipsItem" v-for="(tipsItem, index) in item.tips" :key="index" :style="`margin-bottom: ${index == item.tips.length - 1 ? '20px' : ''}`">
          <i class="iconfont icon-icon_correct" style="width: 16px; height: 16px; color: #8C8C8C;"/>
          <div class="title">{{tipsItem.title}}</div>
        </div>
        <div class="discount" v-if="item.discount && item.discount.length > 0">
          <div class="discountItem">
            <div class="discountItemTitle">{{$t('pro_business_subscribe_item_off').replace('*', item.discount)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {onMounted, defineEmits} from "vue";
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import Toast from "@/utils/toast";
import clipboardCopy from "clipboard-copy";
// import {shareWebsiteGoogleStatistics} from "@/config/googleStatistics"
import {storeToRefs} from "pinia";
import useUserStore from "@/store/modules/user"
import useBasicStore from "@/store/modules/basic"
import useProStore from "@/store/modules/pro"
import { getProBusinessSubscribeConfig } from "@/config/proConfig"
import type { SubscribeConfigItem } from "@/types/pro"
import freeIcon from "@/assets/images/pro/icon_fire@2x.png"
import type ProDialog from '~/components/Pro/ProDialog/ProDialog.vue'

const router = useRouter()
const route = useRoute()
const propsParam = ref({})  // btnBgColor btnSelectBgColor btnBorderColor
const proList: SubscribeConfigItem[] = ref([])
interface Props {
  coin?: string
}
const props = defineProps<Props>()
let call = defineEmits(["onSubscribe"])
const {t, locale} = useI18n()
const userStore = useUserStore();
const { token, roleRightsMap, userRights, bizTeamInfo} = storeToRefs(userStore);
const basicStore = useBasicStore();
const { isChina } = storeToRefs(basicStore);
const proStore = useProStore();
const { proConfig } = storeToRefs(proStore);

const proDialogRef = inject('proDialogRef') as Ref<InstanceType<typeof ProDialog>>

watch(
  () => props.coin,
  () => {
    getProList(props.coin)
  }
)

watch(
  () => userRights.value,
  () => {
    getProList(props.coin)
  },
  {
    deep: true
  }
)

watch(
  () => roleRightsMap.value,
  () => {
    getProList(props.coin)
  },
  {
    deep: true
  }
)

watch(
  () => proConfig.value,
  () => {
    getProList(props.coin)
  },
  {
    deep: true
  }
)

const getStyleFontSize = () => {
  if (locale.value == 'en' || locale.value == 'id' || locale.value == 'uk' || locale.value == 'itb') {
    return '16px'
  }else if (locale.value == 'de' || locale.value == 'fr') {
    return '12px'
  }
  return '24px'
}

const getCurrencyTitle = () => {
  if (props.coin) {
    return userStore.getCurrentCoinSymbol(props.coin)
  }
  let coinKey = userStore.getCurrentLangSymbol(locale.value)
  return coinKey
}

const viewport = useViewport();
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))

function onSubscribe(item: SubscribeConfigItem) {
  console.log("onSubscribe", item, proDialogRef)
  // 如果是移动端
  if (!isDesktop.value) {
    Toast(t('go_web_version'))
    return
  }
  proDialogRef.value?.open({...item, mode: 0})
}

function onCustomized(item: SubscribeConfigItem) {
  if (window.$crisp && window.$crisp.do) {
		window.$crisp.do('chat:open')
	}
}

function getProList(coin?: string) {
  let coinKey = ''
  if (coin) {
    coinKey = coin.toLocaleLowerCase()
  } else {
    coinKey = userStore.getCurrentCoin(locale.value)
  }
  proList.value = getProBusinessSubscribeConfig(coinKey)
}

onMounted(()=>{
  if (props.coin) {
    getProList(props.coin)
  } else {
    getProList()
  }
})
</script>

<style lang="scss" scoped>
.pro-subscribe{
  flex-direction: column;
  display: flex;
  position: relative;
  min-height: 570px;
  margin: 0 15px;
  border-radius: 4px;
  .pro-subscribe-list {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    gap: 30px; /* 设置间距为20px */
    .pro-subscribe-list-item {
      width: 276px;
      height: 100%;
      display: flex;
      flex-direction: column;
      background-color: white;
      border: 1px solid #BFBFBF;
      border-radius: 4px;
      padding: 30px 30px;
      position: relative;
      &:hover {
        box-shadow: 0px 0px 16px 1px rgba(0,0,0,0.16);
        border: 1px solid #2590E1;
      }
      .item-top {
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          color: #262626;
          font-size: 24px;
          line-height: 24px;
        }
        .title_desc_customized {
          height: 120px;
          width: 218px; 
          margin-top: 10px; 
          display: flex; 
          flex-direction: row; 
          justify-content: center;
          .pro-subscribe-subTitle {
            color: #8C8C8C;
            font-size: 14px;
            overflow: hidden; /* 隐藏超出容器的文本 */
            text-overflow: ellipsis; /* 显示省略号来表示文本被截断 */
            -webkit-line-clamp: 6; //这儿的数字代表的就是你所需要实现效果的第N行
            -webkit-box-orient: vertical;
            display: -webkit-box;
            line-height: 20px;
          }
        }
        .title_desc {
          width: 218px; 
          height: 40px;
          margin-top: 10px; 
          display: flex; 
          flex-direction: row; 
          justify-content: center;
          .pro-subscribe-subTitle {
            color: #8C8C8C;
            font-size: 14px;
            display: -webkit-box;
            overflow: hidden; /* 隐藏超出容器的文本 */
            text-overflow: ellipsis; /* 显示省略号来表示文本被截断 */
            -webkit-line-clamp: 2; //这儿的数字代表的就是你所需要实现效果的第N行
            -webkit-box-orient: vertical;
            line-height: 20px;
          }
        }
      }
    }
  }
  .priceItem {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 20px 0;
    height: 60px;
    .item-char {
      display: flex;
      .item-char-title {
        color: #2590E1;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .item-pdf {
      display: flex;
      margin-top: 10px;
      .item-pdf-title {
        color: #BFBFBF;
        font-size: 14px;
      }
    }
  }

  .item-price {
    display: flex;
    width: 100%;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #BFBFBF;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    &:hover {
      border: 1px solid #2590E1;
    }
    .item-price-title {
      color: #262626;
      font-size: 16px;
    }
  }
  .item-customized {
    display: flex;
    margin-top: 20px;
    width: 100%;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #2590E1;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    &:hover {
      opacity: 0.6;
    }
    .item-customized-title {
      color: #2590E1;
      font-size: 16px;
    }
  }

  .freeLine {
    width: 216px;
    height: 1px;
    background: #BFBFBF;
    border-radius: 4px 4px 4px 4px;
    margin-top: 20px;
  }

  .tipsItem {
    flex-direction: row;
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    border-radius: 4px;
    // align-items: center;
    margin-top: 20px;
    .title {
      margin-left: 10px;
      color: #595959;
      font-size: 13px;
    }
  }
  .discount {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    min-width: 50px;
    height: 20px;
    background-color: #E14C25;
    border-radius: 4px 4px 4px 0px;
    .discountItem {
      min-width: 50px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      padding: 0 5px;
      .discountItemTitle {
        color: white;
        font-size: 12px;
      }
    }

    .triangle {
      position: relative;
      width: 111px; /* 或者您需要的宽度 */
      height: 40px; /* 矩形的高度 */
      background-color: #E14C25; /* 矩形的背景色 */
    }
    .triangle:after {
      position: absolute;
      content: '';
      width: 0px;
      height: 0px;
      background: #E14C25;
      top: 0px;
      right: 0px;
      border-right: 10px solid rgba(255, 255, 255, 1.0); /* 左边边框生成三角形，半透明的白色 */
      border-top: 20px solid transparent; /* 上边边框透明，形成凹槽效果 */
      border-bottom: 20px solid transparent; /* 下边边框透明 */
    }
  }
}
</style>
